<template>
  <div>
    <!-- 弹出网站介绍 -->
    <Popup
      v-model:show="sitedData.showIntro"
      round
      position="bottom"
      closeable
      close-icon="close"
      :style="{ height: '75%' }"
    >
      <Intro />
    </Popup>
    <Swipe
      :show-indicators="false"
      :touchable="false"
      ref="swipe"
      @change="swipeChange"
    >
      <!-- 步骤一项 -->
      <SwipeItem>
        <Step_1 />
      </SwipeItem>
      <!-- 步骤二项 -->
      <SwipeItem class="Step2">
        <Step_2 />
      </SwipeItem>
    </Swipe>
    <!-- 控制步骤按钮区 -->
    <div class="BottomNav">
      <!-- 步骤一按钮 -->
      <Button
        v-if="sitedData.Step == 0"
        type="primary"
        block
        @click="NextStep"
        v-bind:disabled="!sitedData.page1_StepState"
        >下一步</Button
      >
      <!-- 步骤二按钮 -->
      <div v-if="sitedData.Step == 1" style="width: 100%">
        <Button type="primary" @click="PrevStep" style="width: 30%"
          >上一步</Button
        >
        <Button
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          style="width: 70%"
          @click="SubmitOrder"
          :disabled="!sitedData.page2_StepState"
        >
          提交订单
        </Button>
        <Popup
          v-model:show="OrderShow"
          closeable
          close-icon="close"
          position="bottom"
          :style="{ height: '80%', backgroundColor: '#f7f8fa' }"
        >
          <Order />
        </Popup>
      </div>
    </div>
  </div>
</template>
<script setup>
import Step_1 from "@/pages/index/Step1";
import Step_2 from "@/pages/index/Step2";
import Order from "@/pages/index/Step2/order.vue";
import { getCurrentInstance, ref } from "vue";
import { Swipe, SwipeItem, Button, Dialog, Notify, Popup, Toast } from "vant";
import { groupService } from "@/service/groupService";
import { payService } from "@/service/payService";
import { useData } from "@/composables/useData.js";
import Intro from "@/components/intro.vue";
// 获取 this 实例
const { proxy } = getCurrentInstance();
// 引入共享数据
const { sitedData } = useData();
// 主组件方法
const OrderShow = ref(false);
// const intro = ref(false); // 是否显示网站简介
// 上一步
const PrevStep = () => {
  proxy.$refs.swipe.prev();
};
// 下一步
const NextStep = () => {
  const toast = Toast.loading({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });
  // 现行判断是否加入课群
  groupService
    .isInGroup(
      sitedData.value.groupID,
      sitedData.value.user.userID,
      sitedData.value.user.yibanID,
      sitedData.value.user.userToken
    )
    .then((res) => {
      toast.clear();
      if (res.result) {
        proxy.$refs.swipe.next();
      } else {
        Dialog.confirm({
          title: "号外号外~",
          message: "您未加入此课群，是否现在加入？",
          cancelButtonText: "我就不加",
          confirmButtonText: "立即加入~",
        })
          .then(() => {
            const toast = Toast.loading({
              message: "加载中...",
              forbidClick: true,
              duration: 0,
            });
            console.log(sitedData.value);
            groupService
              .joinGroup(
                sitedData.value.groupID,
                sitedData.value.user.sessionID
              )
              .then((res) => {
                toast.clear();
                if (res.state == "success") {
                  proxy.$refs.swipe.next();
                } else {
                  Notify({
                    type: "danger",
                    message:
                      res.result == ""
                        ? "网络通信问题，请再试一次"
                        : res.result,
                  });
                }
              });
          })
          .catch(() => {
            // console.log("服了服了");
          });
      }
    })
    .catch((err) => {
      toast.clear();
      Notify({
        type: "danger",
        message: err.result == "" ? "网络通信问题，请再试一次" : err.result,
      });
    });
};
// 更新轮播下标
const swipeChange = (index) => {
  sitedData.value.Step = index;
};

// 提交订单
const SubmitOrder = () => {
  // 生成一个6位数字的随机数
  let order = sitedData.value.order;
  if (!sitedData.value.page2_StepState) {
    Notify({
      type: "danger",
      message: "你没有选择课群!!",
    });
  }

  const toast = Toast.loading({
    message: "提交订单...",
    forbidClick: true,
    duration: 0,
  });
  console.log(order.targetScores);
  let inviteCode = localStorage.getItem("inviteCode")
    ? localStorage.getItem("inviteCode")
    : "";
  payService
    .precreate(
      sitedData.value.user.userInfo,
      order.examId,
      sitedData.value.user.tel,
      order.targetScores,
      order.maxScores,
      order.targetExamTime,
      order.maxExamTime,
      order.groupTitle,
      order.examTitle,
      order.groupImg,
      sitedData.value.user.userID,
      sitedData.value.groupID,
      inviteCode,
      sitedData.value.user.yibanID,
      sitedData.value.user.userToken,
      sitedData.value.user.tel,
      sitedData.value.user.password
    )
    .then((res) => {
      toast.clear();
      // 问题判断
      if (res.state != "success") {
        Notify({
          type: "danger",
          message: res.message,
        });
        return;
      }
      order.alipay.id = res.result.qr.id;
      order.alipay.qrCode = res.result.qr.qrCode;
      order.orderPrice = res.result.money;
      order.orderID = res.result.orderId;
      // 写入session
      localStorage.setItem("orderId", order.orderID);
      OrderShow.value = true;
    })
    .catch((errorRes) => {
      Notify({
        type: "danger",
        message: errorRes,
      });
    });
};

if (!localStorage.getItem("intro")) {
  sitedData.value.showIntro = true;
}

// 检查是否存在订单
let OrderId = localStorage.getItem("orderId");
if (OrderId) {
  Dialog.alert({
    message: "你有进行中的订单！！！",
    theme: "round-button",
    showCancelButton: true,
    confirmButtonText: "这就去",
    cancelButtonText: "算了吧,不要了",
  })
    .then(() => {
      sitedData.value.order.orderID = OrderId;
      OrderShow.value = true;
      proxy.$refs.swipe.next();
    })
    .catch(() => {
      localStorage.removeItem("orderId");
    });
  // return;
}
</script>

<style>
.BottomNav {
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>
